"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermPopup = void 0;
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var VARIANT_HEADER_ICON = {
    definition: 'ReadingMode',
    metric: 'BarChartVertical',
    persona: 'Contact',
    info: 'Info',
    'pain-point': 'Warning',
    risk: 'Warning',
    benefit: 'CheckMark',
};
/**
 * Floating popup shown when a `HighlightedTerm` is clicked. Uses
 * Fabric `Callout` (which portals to `<body>`), so the matching SCSS
 * lives at the root scope of `highlighted-term.scss`.
 */
exports.TermPopup = function (_a) {
    var target = _a.target, content = _a.content, onDismiss = _a.onDismiss;
    var variant = content.variant || 'definition';
    var headerIcon = VARIANT_HEADER_ICON[variant];
    return (react_1.default.createElement(office_ui_fabric_react_1.Callout, { className: "ws-term-popup-host ws-term-popup-host--" + variant, directionalHint: office_ui_fabric_react_1.DirectionalHint.bottomCenter, target: target || undefined, onDismiss: onDismiss, isBeakVisible: true, beakWidth: 12, gapSpace: 6, setInitialFocus: true },
        react_1.default.createElement("div", { className: "ws-term-popup ws-term-popup--" + variant },
            react_1.default.createElement("div", { className: "ws-term-popup-header" },
                react_1.default.createElement(office_ui_fabric_react_1.Icon, { className: "ws-term-popup-header-icon", iconName: headerIcon }),
                react_1.default.createElement("div", { className: "ws-term-popup-header-text" },
                    content.kicker ? react_1.default.createElement("div", { className: "ws-term-popup-kicker" }, content.kicker) : null,
                    content.title ? react_1.default.createElement("div", { className: "ws-term-popup-title" }, content.title) : null)),
            react_1.default.createElement("div", { className: "ws-term-popup-body" }, content.bodyHtml ? (react_1.default.createElement("div", { className: "ws-term-popup-body-html", 
                // Trusted: content is sourced server-side / from an
                // internal popup-data provider, not user-typed markdown.
                dangerouslySetInnerHTML: { __html: content.bodyHtml } })) : (react_1.default.createElement("p", { className: "ws-term-popup-body-text" }, content.body || ''))))));
};
